import { useCallback, useEffect } from "react"
import ReactGoogleRecaptcha, { ReCAPTCHAProps } from "react-google-recaptcha"
import styled from "styled-components"

type Props = {
  /** 成功した時はtrueが送られる */
  onChange: (value: string | null) => void
  /** storybook用 */
  onChangeNative?: ReCAPTCHAProps["onChange"]
  /** storybook用 */
  isDev?: boolean
}

const IS_DEV = process.env.ENV === "local"

export const Recaptcha: React.VFC<Props> = ({ onChange, onChangeNative, isDev = IS_DEV }) => {

  if (isDev) {
    useEffect(() => onChange("DEVモード"), [])
    return <MockRecaptcha>DEVモード</MockRecaptcha>
  }

  const SITE_RECAPTCHA_KEY = process.env.RECAPTCHA_API_KEY
  if (typeof SITE_RECAPTCHA_KEY === "undefined") {
    throw new Error("reCAPTCHAキーが設定されていません")
  }

  const onChangeHandler = useCallback(
    (token: string | null) => {
      onChange(token)
      onChangeNative?.(token)
    },
    [onChange, onChangeNative]
  )

  return <ReactGoogleRecaptcha onChange={onChangeHandler} sitekey={SITE_RECAPTCHA_KEY} />
}

const MockRecaptcha = styled.div`
  width: 304px;
  height: 78px;
  background-color: azure;
  display: grid;
  place-items: center;
  font-size: 16px;
  font-weight: bold;
  border: solid black 1px;
`
